import { createContext, useContext } from 'react';

import { GetDealByIdQuery } from '@/lib/graphql/generated/graphql';

type DealFromQuery = NonNullable<GetDealByIdQuery['deal']>;

interface DealContextValue {
  deal: DealFromQuery;
  refetchDeal: () => Promise<unknown>;
}

export const DealContext = createContext<DealContextValue | null>(null);

export function useDealContext(): DealContextValue {
  const ctx = useContext(DealContext);
  if (!ctx) {
    throw new Error(
      'useDealContext must be used within a <DealContext.Provider>. ' +
        'Ensure this component is rendered inside a Layout.'
    );
  }
  return ctx;
}
